import React from "react";
import { Button } from "react-bootstrap";

export default function ModeSwitcher({ mode, setMode }) {
  return (
    <div className="d-flex gap-2 mb-3">
      <Button
        size="sm"
        variant={mode === "roles" ? "info" : "light"}
        onClick={() => setMode("roles")}
      >
        Roles
      </Button>

      <Button
        size="sm"
        variant={mode === "privileges" ? "info" : "light"}
        onClick={() => setMode("privileges")}
      >
        Privileges
      </Button>
    </div>
  );
}
